<template>
    <!-- <div class="home"> -->
    <!-- <v-container class="text-container"  fluid fill-height px-container>
        <v-row class="textRow" align="start" justify="center" v-html="$t('MainPageText')">
        </v-row>
    </v-container>-->
    <!-- </div>    -->

    <div class="fill-height">
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center" class="textRow" v-html="$t('MainPageText')" />
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Home',
    // eslint-disable-next-line
    components: {}
};
</script>

<style scoped>
.textRow {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 30px;
    line-height: 52px;
    text-align: center;
    color: #8f8f8f;
}
.text-container {
    position: absolute;
    /* width: 561px; */
    height: 100px;
    /* left: 439px; */
    top: 130px;
}
</style>
